import { define } from 'remount';     
import App from "../javascript/components/App";
                                      
define({ 'app-main': App });